<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="row" [formGroup]="EOLAddEditForm" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="col-6">
      <div class="form-group required">
        <label class="sub-header-drpdown">Waste identifier</label>
        <ng-select
          [clearable]="true"
          [clearOnBackspace]="false"
          #wasteIdentifier
          [items]="wasteIdentifierList"
          [searchable]="false"
          bindLabel="name"
          formControlName="wasteIdentifier"
          [searchFn]="commonInputSearch"
          (change)="selectedWasteIdentifier($event)"
          placeholder="Waste identifier list"
        >
          <ng-template ng-header-tmp>
            <div class="has-feedback">
              <input
                type="text"
                placeholder="Search..."
                (input)="wasteIdentifier.filter($any($event.target).value)"
                class="form-control accordion-search search-input"
                id="inputValidation"
              />
              <span class="form-control-feedback">
                <i class="fa fa-search icon"></i>
              </span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
          </ng-template>
        </ng-select>
        <div
          *ngIf="
            (EOLAddEditForm.controls['wasteIdentifier']?.touched &&
              EOLAddEditForm.controls['wasteIdentifier']?.invalid) ||
            (submitted && !EOLAddEditForm.controls['wasteIdentifier'].value?.name)
          "
          class="input-error"
        >
          Waste identifier is required.
        </div>
      </div>
    </div>

    <div class="col-6">
      <div class="form-group required">
        <label class="sub-header-drpdown">Country</label>
        <ng-select
          [clearable]="true"
          [clearOnBackspace]="false"
          #country
          [items]="countryList"
          [searchable]="false"
          bindLabel="name"
          (change)="selectedNation($event)"
          formControlName="country"
          [searchFn]="commonInputSearch"
          placeholder="Country *"
          [readonly]="true"
        >
          <ng-template ng-header-tmp>
            <div class="has-feedback">
              <input
                type="text"
                placeholder="Search..."
                (input)="country.filter($any($event.target).value)"
                class="form-control accordion-search search-input"
                id="inputValidation"
              />
              <span class="form-control-feedback">
                <i class="fa fa-search icon"></i>
              </span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
          </ng-template>
        </ng-select>
        <div
          *ngIf="
            (EOLAddEditForm.controls['country']?.touched &&
              EOLAddEditForm.controls['country']?.invalid) ||
            (submitted && !EOLAddEditForm.controls['country'].value?.name)
          "
          class="input-error"
        >
          Country is required.
        </div>
      </div>
    </div>
  </div>

  <div class="row" [formGroup]="EOLAddEditForm" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="col-4">
      <div class="form-group required" aria-required="true">
        <piqet-angular-common-input
          label="Product weight (kg)"
          name="productWeight"
          placeholder="Product weight (kg)"
          formControlName="productWeight"
          [control]="EOLAddEditForm.controls['productWeight']"
          [submitted]="submitted"
          [maxLength]="50"
          inputType="number"
          [disabled]="true"
        ></piqet-angular-common-input>
      </div>
    </div>

    <div class="col-4">
      <div class="form-group required" aria-required="true">
        <piqet-angular-common-input
          label="Product disposal at EOL (%)"
          name="productDisposal"
          placeholder="Product disposal at EOL"
          formControlName="productDisposal"
          [control]="EOLAddEditForm.controls['productDisposal']"
          [submitted]="submitted"
          [maxLength]="50"
          inputType="number"
          [required]="true"
          [preventNegative]="true"
          [maxValue]="100"
          [enableRangeValidation]="true"
          (customBlur)="getAmtofProductDisposal()"
          [errorMessages]="{
            max: 'Product disposal can be less than or equal to 100',
            nonNegative: 'Product disposal (%) can\'t be negative',
            greaterThanZero: 'Product disposal must be greater than 0.'
          }"
        ></piqet-angular-common-input>
      </div>
    </div>

    <div class="col-4">
      <div class="form-group required" aria-required="true">
        <piqet-angular-common-input
          label="Amount of product disposed"
          name="amtOfProductDisposal"
          placeholder="Amount of product disposed"
          formControlName="amtOfProductDisposal"
          [control]="EOLAddEditForm.controls['amtOfProductDisposal']"
          [submitted]="submitted"
          [maxLength]="50"
          inputType="number"
          [required]="true"
          [disabled]="true"
        ></piqet-angular-common-input>
      </div>
    </div>
  </div>

  <div *ngIf="errorMessage" class="input-error mb-3">
    {{ errorMessage }}
  </div>
  <div class="modal-footer extraPadding">
    <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" *ngIf="showEdit" (click)="onSave()">
      Save
    </button>
  </div>
</div>
